import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Button, TextField, Select, MenuItem, InputLabel, FormControl, Menu } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';

// Import Icon
import quePoolIcon from "../../assets/icons/configurationIcons/que-pool-icon.svg";
import leftIcon from "../../assets/icons/configurationIcons/pagination-left-icon.svg";
import rightIcon from "../../assets/icons/configurationIcons/pagination-right-icon.svg";
import resultIcon from "../../assets/icons/configurationIcons/pagination-more-results-icon.svg";

// Import Css
import "./Pagination.css"
import { atomSearchValue, currentPageAtom, itemsPerPageAtom } from '../../recoil-store/recoil-state';

// const itemsPerPageOptions = [5, 10, 25, 100]


const Pagination = React.memo(({ stopFetch, trigger, totalItems, callFetch, showType, expand, outItemsPerPageLimit, outItemsPerPage,
    reset, displayNone, triggerFetch, fetchParentItems, outPage, from, disabled }) => {
    // const [itemsPerPage, setItemsPerPage] = useState(8);
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    // const [currentPage, setCurrentPage] = useRecoilState(currentPageAtom);
    // const [itemsPerPage, setItemsPerPage] = useRecoilState(itemsPerPageAtom);
    const [itemsPerPage, setItemsPerPage] = useState(outItemsPerPage ? outItemsPerPage : 10);
    const [maxPage, setMaxPage] = useState(1);
    const [searchValue, setSearchValue] = useRecoilState(atomSearchValue);
    const [firstPaginationRender, setFirstPaginationRender] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const itemsPerPageOptions = [10, 25, 50, 100]

    useEffect(() => {
        setFirstPaginationRender(true)
    }, []);

    useEffect(() => {
        if (firstPaginationRender && outPage) {
            setCurrentPage(outPage)
        }
    }, [outPage]);

    // useEffect(() => {
    //     if (outItemsPerPageLimit && !outItemsPerPageLimit.includes(itemsPerPage)) {
    //         setItemsPerPage(outItemsPerPageLimit[0])
    //     }
    // }, [outItemsPerPageLimit]);
    useEffect(() => {
        if (!stopFetch && firstPaginationRender) {
            callFetch((currentPage - 1) * itemsPerPage, itemsPerPage, undefined, currentPage)
            if (fetchParentItems && totalItems === 1 && firstPaginationRender) {
                fetchParentItems()
            }
        }
        // else if (!stopFetch && from === "monitoring") {
        //     callFetch((currentPage - 1) * itemsPerPage, itemsPerPage)
        // }
    }, [trigger]);

    // useEffect(() => {
    //     if (triggerFetch?.length) {
    //         callFetch((currentPage - 1) * itemsPerPage, itemsPerPage)
    //     }
    // }, [triggerFetch?.length]);
    useEffect(() => {
        if (firstPaginationRender) {
            callFetch((currentPage - 1) * itemsPerPage, itemsPerPage, true, currentPage)
        }
    }, [triggerFetch]);

    useEffect(() => {
        if (callFetch, expand) {
            callFetch(0, itemsPerPage) // , searchValue
        }
        if (currentPage !== 1) {
            setCurrentPage(1)
        }
    }, [searchValue]);

    useEffect(() => {
        if (firstPaginationRender) {
            setCurrentPage(1)
            setItemsPerPage(10)
        }
    }, [reset]);

    useEffect(() => {
        if (outItemsPerPage) {
            setItemsPerPage(outItemsPerPage)
        }
    }, [outItemsPerPage]);

    useEffect(() => {
        if (itemsPerPage, totalItems) {
            const maxPage = Math.ceil(totalItems / itemsPerPage);
            setMaxPage(maxPage)
        }
        else if (totalItems === 0) {
            setMaxPage(1)
        }
    }, [totalItems, itemsPerPage]);

    const handlePageChange = (page) => {
        if (page === currentPage) {
            return
        }
        if (page > maxPage) {
            setCurrentPage(maxPage);
            page = maxPage
        }
        else if (page === 0) {
            setCurrentPage(1);
            page = 1
        }
        else {
            setCurrentPage(page);
        }
        callFetch((page - 1) * itemsPerPage, itemsPerPage, undefined, page)
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (value) => {
        setAnchorEl(null);
        if (value) {
            handleItemsPerPageChange(value);
        }
    };

    const handleItemsPerPageChange = (value) => {
        setItemsPerPage(value);
        setCurrentPage(1);
        callFetch(0, value)
    };


    return (
        <div style={{ display: `${displayNone ? "none" : "flex"}` }} className={`pagination-container ${showType !== "singleView" ? "queue-childs-pagination" : ""}`}>
            <div className='page-change-area'>
                {/* <Button className='pagination-button pagination-button-icon' onClick={() => handlePageChange(1)} disabled={currentPage === 1}><FirstPageIcon /> </Button> */}
                {![1, 2].includes(currentPage) ? <><Button className='pagination-button pagination-button-number' disabled={disabled}
                    style={{ opacity: `${1 === currentPage ? "1" : "0.5"}` }}
                    onClick={() => handlePageChange(1)}
                    color={1 === currentPage ? '#46474E' : 'default'}>
                    {1}
                </Button>
                    {currentPage !== 3 && <span className='three-dot'>...</span>}</> : ""}
                {[...Array(3)].map((_, index) => {
                    const page = currentPage - 1 + index;
                    if (page > 0 && page <= maxPage) {
                        return <Button className={`pagination-button pagination-button-number ${page === currentPage ? "active-page-number" : ""}`} key={page} disabled={disabled}
                            style={{ opacity: `${page === currentPage ? "1" : "0.5"}` }} onClick={() => handlePageChange(page)}
                            color={page === currentPage ? '#46474E' : 'default'} disableRipple={page === currentPage}>
                            {page}
                        </Button>;
                    }
                    return null;
                })}
                {
                    ![maxPage - 1, maxPage].includes(currentPage) ? <>
                        {currentPage !== maxPage - 2 && <span className='three-dot'>...</span>}
                        <Button className='pagination-button pagination-button-number' style={{ opacity: `${maxPage === currentPage ? "1" : "0.5"}` }} onClick={() => handlePageChange(maxPage)}
                            color={maxPage === currentPage ? '#46474E' : 'default'}>
                            {maxPage}
                        </Button >
                    </> : ""
                }
                <Button className='m-l-10 pagination-button pagination-button-icon' onClick={() => handlePageChange(currentPage - 1)} disabled={disabled || currentPage === 1}><img src={leftIcon} /></Button>
                <Button className='pagination-button pagination-button-icon' onClick={() => handlePageChange(currentPage + 1)} disabled={disabled || currentPage === maxPage}><img src={rightIcon} /> </Button>
                {/* <Button className='pagination-button pagination-button-icon' onClick={() => handlePageChange(maxPage)} disabled={currentPage === maxPage}><LastPageIcon /> </Button> */}
            </div >
            <TextField
                type="number"
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                InputProps={{ inputProps: { min: 1, max: maxPage } }}
                margin="normal"
                className='go-to-page-container'
                disabled={disabled}
            />
            <div className='pagination-more-items-container'>
                <span className='pagination-display-text'>{t("MESSAGES.MONITORING.DISPLAY")}</span>
                <span onClick={(e) => handleOpenMenu(e)} className='pagination-result-text'>{itemsPerPage} {t("MESSAGES.MONITORING.RESULT")}
                    <img src={resultIcon} />
                </span>
                <Menu
                    id="items-per-page-menu"
                    anchorEl={anchorEl}
                    // keepMounted
                    open={open}
                    onClose={() => handleClose(null)}
                >
                    {itemsPerPageOptions.map((option) => (
                        <MenuItem className='pagination-per-page-menu-item' key={option} onClick={() => handleClose(option)} disabled={disabled}>
                            {option} {t("MESSAGES.MONITORING.RESULT")}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        </div >
    );
})

export default Pagination;